<template>
    <div id="headerDiv">
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/icon/loading.gif" alt="">
            </div>
        </div>
        <span v-if="isHeader">
            <div class="black-layout" v-on:click="closepopup()"></div>
            <div class="hamburger-menu">
                <div class="menu-content">
                    <div class="container-fluid pt-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="close-hamburger">
                                    <i class="material-icons">close</i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-12">
                                <ul class="menu-list sidebar">
                                    <li>
                                        <router-link to="/"><i class="fa fa-home icon-change" aria-hidden="true"></i>Home</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/dashboard"><i class="fa fa-tachometer icon-change" aria-hidden="true"></i>Dashboard</router-link>
                                    </li>
                                    <li class="border-bottom">
                                        <router-link to="/lab"><i class="fa fa-flask icon-change" aria-hidden="true"></i>Book Test </router-link>
                                    </li>
                                
                                    <li v-if="profile">
                                        <router-link to="/myprofile"><i class="fa fa-user-o icon-change" aria-hidden="true"></i>My Profile</router-link>
                                    </li>
                                    <li v-if="profile">
                                        <router-link to="/referral/invite"><i class="fa fa-money icon-change" aria-hidden="true"></i>Refer & Earn</router-link>
                                    </li>
                                    <li v-if="profile">
                                        <router-link to="/myresult"><i class="fa fa-file-pdf-o icon-change" aria-hidden="true"></i>My Result</router-link>
                                    </li>
                                    <li  v-if="profile" class="border-bottom">
                                        <a v-on:click="logout()" class="red-color">
                                            <i class="fa fa-power-off icon-change" aria-hidden="true"></i>
                                            Logout
                                            <span class="user-name">Hi, {{profile.firstName}}</span>
        </a>
        </li>
        <li v-if="!profile" class="border-bottom">
            <a href="#" data-toggle="modal" data-target=".login-box" @click="loginClicked()" data-backdrop="static" data-keyboard="false"><i class="fa fa-sign-out  icon-change" aria-hidden="true"></i>Login / Sign Up</a>
        </li>
        <li v-if="!isApp">
            <router-link to="/phlebotomist-signup"><i class="fa fa-user-md icon-change" aria-hidden="true"></i>Phlebotomist Sign Up</router-link>
        </li>
        <li v-if="!isApp">
            <router-link to="/lab-signup"><i class="fa fa-medkit icon-change" aria-hidden="true"></i>Lab Sign Up</router-link>
        </li>
        <li>
            <router-link to="/contact-us"><i class="fa fa-address-book-o icon-change" aria-hidden="true"></i>Contact Us</router-link>
        </li>
        <li>
            <router-link to="/about-us"><i class="fa fa-address-card-o icon-change" aria-hidden="true"></i>About Us </router-link>
        </li>
        <li>
            <router-link to="/terms"><i class="fa fa-pencil-square-o icon-change" aria-hidden="true"></i>Terms and Conditions</router-link>
        </li>
        <li>
            <router-link to="/privacy-policy"><i class="fa fa-file-text-o icon-change" aria-hidden="true"></i>Privacy Policy</router-link>
        </li>
        </ul>
    </div>
    </div>
    </div>
    </div>
    </div>
    <div class="header">
        <div class="container-fluid" v-if="!(step)">
            <div class="row">
                <div class="col-sm-12">
                    <div class="menu" style="cursor:pointer">
<i class="material-icons">menu</i>
</div>
<div class="logo float-left">
    <router-link to="/"><img src="static/images/logo-svg.svg" alt=""></router-link>
</div>
<!-- <div class="float-left cont-number">
    <h5 class="mt-2 contact-call-p" ><a href="tel:+919025662566"> <span class="fa fa-phone"></span> 90256 62566</a></h5>
</div> -->
<ul class="text-center top-menu float-right">
    <!--<li v-if="$route.fullPath === '/' || $route.fullPath === '/login' || $route.fullPath === '/myprofile'">
        <router-link to="/lab">
            <span class="sprites sprite-flask"></span>
            <span class="menu-label">Book Test</span>
        </router-link>
    </li>-->
    <li class="dropdown" v-if="cartCount <= 0 && !isHealthCartEnabled">
        <a v-on:click="healthCartClicked()">
            <span>
                                            <span class="sprites sprite-care"></span>
            <span class="menu-label">Health Cart</span>
            <span v-if="cartCount > 0" class="count-cart">{{cartCount}}</span>
            </span>
        </a>
    </li>
    <li v-if="cartCount > 0 && !isHealthCartEnabled">
        <a v-on:click="healthCartClicked()">
            <span class="sprites sprite-care"></span>
            <span class="menu-label">Health Cart</span>
            <span v-if="cartCount > 0" class="count-cart">{{cartCount}}</span>
        </a>
    </li>
</ul>
</div>
</div>
</div>
<div class="container-fluid" v-if="(step)">
    <!-- <div class="row">
                        <div class="col-sm-12">
                            <div class="menu" >
                                <a href="javascript:void(0)"  @click="goBackPopup()" style="color:#9e9e9e">
                                <i class="material-icons">
                                    arrow_back
                                </i>
                                </a>
                            </div>
                            <h3 class="screen-title mt-13p">
                                <span v-bind:class="{'active': (tab=='health')}">
                                    Health Cart
                                </span>
                                <span class="float-right gray-color">
                                    Step {{count++}} of 3
                                </span>
                            </h3>
                        </div>
                    </div> -->
</div>
<Login />
</div>
<div class="modal fade" id="Health-cartpopup" tabindex="-1" role="dialog" aria-labelledby="Health-cartpopups" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <!--<div class="modal-header">
                            <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                                <i class="material-icons">
                                    arrow_back
                                </i>
                            </button>
                            <h5 class="modal-title">
                                Health Cart
                            </h5>
                        </div>-->
            <div class="header">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="menu_popup" data-dismiss="modal" aria-label="Close">
                                <i class="material-icons">arrow_back</i>
                            </div>
                            <h3 class="screen-title mt-13p">Health Cart</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-body health-cart-popup">
                <div class="container-fluid">
                    <div class="row" v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0">
                        <div class="col-12">
                            <div v-if="lab && testCosts">
                                <div v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0" class="alert alert-success mb-0 drop-shadow">
                                    Test(s) and/or Panel(s) and Lab added to health cart
                                </div>
                                <!-- <div class="alert alert-success mb-0 drop-shadow" role="alert" ng-if="$localStorage.get('ct').date && timeSelected.startTimeDisp && timeSelected.endTimeDisp">
                                                <i class="fa fa-check mr-1"></i> 
                                                <p>{{formatDate($localStorage.get('ct').date) }} BETWEEN {{ timeSelected.startTimeDisp }} to {{ timeSelected.endTimeDisp }}</p>
                                            </div> -->
                            </div>
                            <!-- <div v-if="!lab && selectedProfileAndTest">
                                            <div v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0" class="alert alert-success mb-0 drop-shadow">
                                                <strong><i class="material-icons float-left mr-2">check</i></strong> Test(s) and/or Panel(s) added to health cart
                                            </div>
                                        </div> -->
                            <div v-if="lab && testCosts" class="lab display-flex no-border p-0 mt-3 bg-tranparent">
                                <div class="flex-box">
                                    <div class="lab-logo">
                                        <img v-if="lab.logo && lab.logo.length > 0" :src="lab.logo" />
                                    </div>
                                </div>
                                <div class="flex-box">
                                    <p class="black-color font-weight-bold mb-2">
                                        {{ lab.labName }} {{lab.branch.branchLocation+', '+lab.branch.branchCity+' - '+lab.branch.branchZipCode}}
                                    </p>
                                    <!-- <span class="mt-0 mb-1 grey-color">{{lab.labLocation+', '+lab.labCity+' - '+lab.labZipCode}}</span> -->
                                    <a href="javascript:void(0)" class="text-uppercase font-weight-bold" @click="goToLab()" data-dismiss="modal">Change Lab</a>
                                </div>
                            </div>
                            <div v-if="lab && testCosts && testCosts.priceDetails && testCosts.priceDetails.length > 0" class="table-responsive test-conformation">
                                <table class="table">
                                    <tbody class="black-color">
                                        <tr v-for="(testProfile, index) in testCosts.priceDetails" :key="index">
                                            <td>{{testProfile.aliasName}}</td>
                                            <td>
                                                <p class="red-color  mt-1 mb-0 strip-text text-nowrap" v-if="parseInt(testProfile.actualPrice) > parseInt(testProfile.ourPrice)">Rs. {{testProfile.actualPrice}}</p>
                                            </td>
                                            <td>
                                                <p class="float-right mt-1 mb-0 price-tag">
                                                    Rs. {{testProfile.ourPrice}}
                                                </p>
                                            </td>
                                            <td>
                                                <button class="btn btn-link remove-btn p-0" @click.prevent="removeSelectedItemsInLab(testProfile)">
                                                                <img :src="closeImg" alt="">
                                                            </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="border-bottom">
                                        <tr>
                                            <td>Sub total</td>
                                            <td></td>
                                            <td>
                                                <p class="float-right mt-1 mb-0 price-tag">
                                                    Rs. {{testCosts.ourPrice}}
                                                </p>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div v-if="!lab && selectedProfileAndTest">
                                <div v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0" class="alert alert-success mb-0 drop-shadow">
                                    <strong><i class="material-icons float-left mr-2">check</i></strong> Test(s) and/or Panel(s)
                                    added to health cart
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="table-responsive test-conformation" v-if="!lab && selectedProfileAndTest">
                                <table class="table">
                                    <tbody class="black-color">
                                        <tr v-for="(testProfile, index) in selectedProfileAndTest" :key="index">
                                            <td>
                                                {{testProfile.name}}
                                            </td>
                                            <td class="text-right">
                                                <button class="btn btn-link remove-btn p-0" @click.prevent="removeSelectedItems(testProfile)">
                                                                <img src="static/images/close-black.svg" alt="">
                                                            </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <a href="javascript:void(0)" class="btn btn-outline-primary" @click="backTest()"> 
                                            Add Test
                                        </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="fixed-footer p-0" id="fixed-footer-cart">
        <button class="btn btn-primary full-width fixed-button" v-if="!lab" @click="selectLab()" data-dismiss="modal">
                        Select Lab
                    </button>
        <button class="btn btn-primary full-width fixed-button" v-if="lab" @click="proccedtoHealthCart()">Proceed to health cart</button>
    </div>
</div>
</span>
</div>
</template>

<script>

    import Login from '@/components/mobile/Login'
    import closeImg from '../../../static/images/close-black.svg'
    import _ from 'underscore'
    import dateFormat from 'dateformat'
    import Vue from 'vue'

    export default {
        name: 'HeaderVue',
        props: ['step', 'tab', 'isHealthCartEnabled', 'isHeader'],
        components: {
            Login
        },
        data() {
            return {
                loggedin_username: '',
                locality: undefined,
                lab: undefined,
                selectedProfileAndTest: undefined,
                selectedDatetime: undefined,
                closeImg: closeImg,
                testCosts: [],
                cartCount: 0,
                payinfo: {},
                profile: undefined,
                cartDispaly: false,
                isApp: this.$WebView
            }
        },
        mounted: function () {
            this.$root.$on('selectedProfileAndTest', (selectedProfileAndTest) => {
                this.selectedProfileAndTest = selectedProfileAndTest
                this.cartCount = selectedProfileAndTest.length
                this.refreshContent()
            })
            this.$root.$on('bookTest', (bookTest) => {
                location.reload()
            })
            this.$root.$on('isLogin', (isLoggin) => {
                this.refreshContent()
            })
            // $('body').click(function (e) {
            //   if (e.target.id === 'HealthCartDropDownClicks' || $(e.target).parents('#HealthCartDropDownClicks').length) {
            //     this.cartDispaly = true
            //   } else {
            //     this.cartDispaly = false
            //   }
            // }.bind(this))
        },
        created() {
            setTimeout(function () {
                if (this.$WebView) {
                    this.isApp = this.$WebView
                    this.profile = this.$localStorage.get('profile')
                } else {
                    setTimeout(function () {
                        this.isApp = this.$WebView
                        this.profile = this.$localStorage.get('profile')
                    }.bind(this), 2000)
                }
            }.bind(this), 2000)

            if (this.$route.fullPath === '/login') {
                // this.$localStorage.remove('profile')
                // this.$localStorage.remove('userid')
                // this.$localStorage.remove('email')
                // this.$localStorage.remove('refresh_token')
                // this.$localStorage.remove('scope')
                // this.$localStorage.remove('profile')
            }
            if (this.$localStorage.get('profile')) {
                this.loggedin_username = this.$localStorage.get('profile').username
            }
            this.locality = this.$localStorage.get('location')
            this.lab = this.$localStorage.get('sl')
            this.selectedProfileAndTest = this.$localStorage.get('st')
            this.selectedDatetime = this.$localStorage.get('ct')
            this.profile = this.$localStorage.get('profile')
            this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
            if (this.lab) {
                this.getTestCosts()
            }
            setTimeout(function () {
                $('.black-layout').hide();
                $('.menu').click(function () {
                    $('.black-layout').show();
                    $('.hamburger-menu').addClass('show-menu');
                    $('body').css('overflow', 'hidden');
                });
                $('.close-hamburger').click(function () {
                    $('.black-layout').hide();
                    $('.hamburger-menu').removeClass('show-menu');
                    $('body').css('overflow', 'auto');
                })
                    , 300
            })
        },
        methods: {
            closepopup: function () {
                $('.hamburger-menu').removeClass('show-menu')
                $('body').css('overflow', 'auto')
                $('.black-layout').hide()
            },
            healthCartClicked: function () {
                if (this.cartCount <= 0) {
                    let rootpath = this.$route.fullPath.split('/')
                    if (rootpath[1] === 'lab') {
                        $('#popupTest').modal('show')
                    } else {
                        this.$router.push({ path: '/lab' })
                    }
                    return false
                } else {
                    $('#Health-cartpopup').modal('show')
                }
            },
            addTest: function () {
                this.$localStorage.set('addTest', true)
                this.$router.push({ path: '/lab' })
            },
            goToLab: function () {
                this.$router.push({ path: '/lab' })
            },
            backTest: function () {
                // $('#Health-cartpopup').on('hidden', function () {
                //         console.log('lllllllllllllllllllll')
                //     $('.modal-open').modal('show')
                // })
                $('#popupTest').modal('hide')
                $('#Health-cartpopup').modal('hide')
                if (this.$route.fullPath === '/lab') {
                    setTimeout(function () {
                        $('#popupTest').modal('show')
                    }, 300)
                } else {
                    this.$router.push({ path: '/lab' })
                    this.addTest()
                }

            },
            selectLab: function () {
                this.$router.push({ path: '/lab' })
            },
            loginClicked: function () {
                $('.black-layout').hide()
                $('.hamburger-menu').removeClass('show-menu')
                $('body').css('overflow', 'auto')
                Vue.analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'LOGIN CLICKED',
                    contents: '',
                    content_type: 'LOGIN_CLICK'
                })
                this.$root.$emit('loginClicked', true)
            },
            proccedtoHealthCart: function () {
                this.$localStorage.remove('ct')
                this.$localStorage.remove('sa')
                this.$localStorage.remove('sm')
                this.$localStorage.remove('cou')
                $('#Health-cartpopup').modal('hide')
                this.$router.push({ path: '/appointment' })


            },
            openHealthCart: function () {
                console.log('inside the Process')
                $('#Health-cartpopup').modal('show')
                // this.$router.push({path:'/health'})
                //   this.cartDispaly = true
            },
            logout: function () {
                this.$router.push({ path: '/' })
                this.profile = undefined
                this.$clearLocalStorageForLogout()
                //   this.$clienttokenForLogout()
                setTimeout(function () {
                    this.refreshContent()
                    location.reload()
                }.bind(this), 300)
            },
            getTestCosts: function (lab) {
                try {
                    let labTestCosts = []
                    if (this.lab) {
                        if ((this.lab.labTestList).length > 0) {
                            _.each(this.lab.labTestList, function (element) {
                                labTestCosts.push(element.labProfileId)
                            })
                        }
                    }
                    if (labTestCosts.length === 0) {
                        $('#Health-cartpopup').modal('hide')
                        this.$router.push('/lab')
                    }
                    let data = {
                        'labId': (this.lab) ? this.lab.labId : '0',
                        'labTests': labTestCosts
                    }
                    Promise.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
                        if (res.response_code === 0) {
                            if (res.response) {
                                this.testCosts = res.response
                                this.payinfo.mrptotal = res.response.mrp
                                this.payinfo.phlebotomistFee = this.$phlebotomistFee
                                this.payinfo.subtotal = (this.payinfo.mrptotal + this.payinfo.phlebotomistFee)
                                this.payinfo.labDiscount = res.response.youSaved
                                this.payinfo.phlebotomyFeeWaiver = ((this.payinfo.mrptotal - this.payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
                                this.payinfo.total = this.payinfo.subtotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver)
                                this.payinfo.gst = Math.round(((this.payinfo.total) * this.$GSTFee) / 100)
                                this.payinfo.grandtotal = (this.payinfo.total + this.payinfo.gst)
                            }
                        }
                    }.bind(this)).catch(function (err) {
                        console.error(err)
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            removeSelectedItems: function (items) {
                this.$localStorage.remove('st')
                this.$localStorage.remove('cou')
                var index = this.selectedProfileAndTest.indexOf(items)
                this.selectedProfileAndTest.splice(index, 1)
                this.$localStorage.set('st', this.selectedProfileAndTest, 0)
                this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
                if (this.selectedProfileAndTest.length === 0) {
                    this.$localStorage.remove('sl')
                    this.$localStorage.remove('ct')
                    this.lab = undefined
                    this.testCosts = []
                    $('#Health-cartpopup').modal('hide')
                    this.$router.push('/lab')
                }
                this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest)
            },
            removeSelectedItemsInLab: function (items) {
                this.$localStorage.remove('cou')
                this.$localStorage.remove('st')
                this.$localStorage.remove('ct')
                let tests = {}
                this.selectedProfileAndTest.forEach(function (item) {
                    if ((items.testId === item.testId && item.testId !== 0) || (items.panelId === item.panelId && item.panelId !== 0)) {
                        tests = item
                    }
                })
                let labTests = []
                this.lab.labTestList.forEach(function (labTest) {
                    if (!((items.testId === labTest.testId && labTest.testId !== 0) || (items.panelId === labTest.panelId && labTest.panelId !== 0))) {
                        labTests.push(labTest)
                    }
                })
                this.$localStorage.remove('sl')
                this.lab.labTestList = labTests
                this.$localStorage.set('sl', this.lab, 30 * 60 * 1000)
                this.selectedDatetime = undefined
                var index = this.selectedProfileAndTest.indexOf(tests)
                this.selectedProfileAndTest.splice(index, 1)
                this.$localStorage.set('st', this.selectedProfileAndTest, 0)
                this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
                if (this.selectedProfileAndTest.length === 0) {
                    this.$localStorage.remove('sl')
                    this.$localStorage.remove('ct')
                    this.lab = undefined
                    this.testCosts = []
                    $('#Health-cartpopup').modal('hide')
                    this.$router.push('/lab')
                }
                this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest)
                this.getTestCosts()
            },
            refreshContent: function () {
                this.profile = this.$localStorage.get('profile')
                this.locality = this.$localStorage.get('location')
                this.lab = this.$localStorage.get('sl')
                this.selectedProfileAndTest = this.$localStorage.get('st')
                this.selectedDatetime = this.$localStorage.get('ct')
                this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
                if (this.lab) {
                    this.getTestCosts()
                }
            },
            formatDate: function (date, format) {
                return dateFormat(date, format, true)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/mobile/Header.vue